import React, { useState, useEffect, useContext } from 'react';
import StreamWebService from '../classes/StreamWebService';
import LocalMoneyValue from './LocalMoneyValue';
import ReactPlayer from 'react-player';
import { ellipsis, genrateAvatarImageLink, isExternal, url } from '../utils';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import GlobalStateContext from '../context';
import logo from "../assets/images/logo_transparent_cut_for_dark.png";

const Carousel = () => {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [state,] = useContext(GlobalStateContext);
  const { user } = state;

  const itemsPerPage = 5;
  const [overallCount, setOveralCount] = useState(0);
  var itemsSet = 1;
  const [slides, setSlides] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const webs = new StreamWebService();

  const [payload, setPayload] = useState({
    page: itemsSet, perPage: itemsPerPage,
    ppv_value: 0
  });

  const getPublicEvents = () => {
    setIsLoading(true)

    webs.getOpenPublicStreams(payload)
      .then(res => {
        setOveralCount(res.data.overallCount)
        return res.data.entries
      })
      .then(items => {

        setSlides([...slides, ...items]);
      })

      .finally(_ => setIsLoading(false));
  }

  const loadMore = () => {
    setPayload({ ...payload, page: payload.page + 1 })

  }

  const cleanup = () => setSlides([]);
  useEffect(() => {
    getPublicEvents();
  }, [payload])
  useEffect(() => {
    getPublicEvents()
    return cleanup
  }, [])



  const handlePrevClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
  };

  const handleNextClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };



  return (
    <div className="relative w-full  mx-auto bg-black text-white  overflow-hidden shadow-lg  col-span-3   lg:col-span-2 h-full ">
      <div className='flex flex-row justify-between lg:hidden'>
        <div className='m-2 p-1 w-18 h-18 rounded-full'>

          <Link className="home-logo-link" to="/" >
            <img alt="" className="img-fluid w-14  mx-auto" src={logo} />
          </Link>

        </div>
        <div className='m-2 pr-2 my-auto flex flex-row gap-2 md:gap-4'>

          {!state?.user && (<><Link className="text-gray-200 bg-gray-600 p-2 rounded" to="/login" >
            Login
          </Link>
            <Link className="text-gray-200  bg-gray-600 p-2 rounded" to="/signup" >
              Signup
            </Link></>)}
          {state?.user && (<><Link className="text-gray-200 bg-gray-600 p-2 rounded" to="/app" >
            Dashboard
          </Link>
          </>)}

        </div>


      </div>

      <div className="relative flex items-center justify-center h-72 lg:h-full ">
        {slides.map((slide, index) => {
          const isPremium = slide.ppv > 0
          const _itemLink = (!!user || isPremium) ? url(`stream/${slide.id}/watch`, true) : url(`${slide.id}/watch`, false)
          const active = index === currentIndex
          const left = index === (currentIndex - 1 + slides.length) % slides.length;
          const right = index === (currentIndex + 1) % slides.length;
          const fallbackImageUrl = genrateAvatarImageLink(slide.user.name)
          return <div
            key={index}
            className={`absolute  bg-black  transition-transform duration-500 ease-in-out ${active
              ? 'transform translate-x-0  scale-100 z-20  shadow-2xl activeHeroCarousel'
              : left
                ? 'transform -translate-x-2/4 scale-75 z-10  shadow-lg'
                : right
                  ? 'transform translate-x-2/4 scale-75 z-10  shadow-lg'
                  : 'hidden'
              }`}
            style={{ transition: 'all 0.5s ease' }}
          >
            <Link to={_itemLink} >
              <div className="relative h-full w-full">
                {/* <img src={slide.image} alt={slide.title} className="w-full h-full object-cover rounded-lg bg-gray-100" /> */}
                {/* <div style={{backgroundImage:`url(${slide.user?.picture })`}} className="w-64 h-36 object-cover rounded-lg bg-gray-700 lg:w-full lg:h-full  carousel-player"> */}

                {/* </div> */}
                <ReactPlayer muted playIcon={<></>} url={slide.video} playing={currentIndex == index}
                  light={currentIndex !== index ? !isExternal(slide.video) ? slide.image || slide.user?.picture : true : false}
                  className="w-64 h-36 object-cover rounded-lg bg-gray-700 lg:w-full lg:h-full  carousel-player" width={"none"} height={"none"} />

                <span className="absolute top-0 left-0 bg-red-600 text-white text-xs font-bold px-2 py-1">LIVE</span>
                {slide.ppv > 0 && <span className="absolute bottom-0 left-0 text-white text-xs font-bold px-2 py-1"><LocalMoneyValue value={slide.ppv} showSymbol={true} /> </span>}
              </div>
              <div className={`flex  p-1 lg:p-4 ${right ? 'flex-row-reverse' : ''} ${active ? 'justify-center' : ''}`}>
                <div className={`flex items-center  ${active ? 'justify-center' : ''}`}>
                  <div className="flex-shrink-0">
                    {/* <img
                      src={slide.user.picture}
                      alt={slide?.user?.name}
                      className="w-12 h-12 rounded-full bg-gray-100"
                      onError={`this.onerror=null;this.src="${genrateAvatarImageLink(slide.user.name)}"`}
                    /> */}
                    <object data={slide.user.picture} type="image/jpeg" className="w-12 h-12 rounded-full bg-gray-100 m-2">
                      <img src={fallbackImageUrl} alt="Name" />
                    </object>
                  </div>
                  <div className={` ml-1 lg:ml-4  ${active ? 'flex flex-col lg:flex-col' : ''}`}>
                    <div className="lg:text-lg lg:font-bold">{ellipsis(slide.title)}</div>
                    {/* <div className="text-xs lg:text-sm text-gray-400">{slide.views} views</div> */}
                    <div className="text-xs lg:text-sm text-gray-400"> {slide?.user?.name}</div>
                    <div className="flex items-center mt-1 hidden lg:block">
                      {slide.category.map((tag, idx) => (
                        <span key={idx} className="bg-gray-700 text-gray-300 text-xs lg:font-bold lg:px-2 lg:py-1 rounded mr-2">
                          {tag}
                        </span>
                      ))}
                    </div>
                    {/* <div className="text-sm text-gray-200 mt-2">{slide.description}</div> */}
                  </div>
                </div>
              </div>
            </Link>
          </div>


        })}
      </div>
      <button
        onClick={handlePrevClick}
        className="text-lg absolute z-10 top-1/2 left-5 transform -translate-y-1/2 bg-gray-800 text-white px-2 py-1 lg:px-4 lg:py-2 rounded-full focus:outline-none"
      >
        ‹
      </button>
      <button
        onClick={handleNextClick}
        className="text-lg absolute z-10 top-1/2 right-5 transform -translate-y-1/2 bg-gray-800 text-white px-2 py-1 lg:px-4 lg:py-2 rounded-full focus:outline-none"
      >
        ›
      </button>
    </div>
  );
};

export default Carousel;
